module.exports = __webpack_public_path__ + "img/basket2.629caf95.svg";